
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alertAI-sports",
      function () {
        return require("private-next-pages/alertAI-sports/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alertAI-sports"])
      });
    }
  